// About / info-page sections — scroll reveal + stat count-up.
// Loaded once globally in <head>; no-ops on pages without .oab sections.
(function(){
  if (window.__oabReveal) return; window.__oabReveal = true;
  function run(){
    // Disconnect observers from a previous run (e.g. theme-editor shopify:section:load) before re-querying.
    if (window.__oabObs) { try { window.__oabObs.disconnect(); } catch(e){} window.__oabObs = null; }
    if (window.__oabCo)  { try { window.__oabCo.disconnect();  } catch(e){} window.__oabCo  = null; }
    if(!document.querySelector('.oab')) return;
    var els = document.querySelectorAll('.oab .fi:not(.v)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('v'); }); return; }
    var o = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('v'); o.unobserve(e.target); } }); },{ threshold:.1, rootMargin:'0px 0px -40px 0px' });
    els.forEach(function(e){ o.observe(e); });
    window.__oabObs = o;
    var cs = document.querySelectorAll('.oab-stat__n[data-count]:not([data-done])');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce){ cs.forEach(function(e){ e.setAttribute('data-done','1'); }); }
    else {
      cs.forEach(function(e){ e.textContent='0'+(e.dataset.suffix||''); });
      var co = new IntersectionObserver(function(es){ es.forEach(function(e){ if(!e.isIntersecting) return; var el=e.target; el.setAttribute('data-done','1'); var t=parseInt(el.dataset.count,10)||0, s=el.dataset.suffix||'', d=1400, t0=performance.now(); (function k(n){ var p=Math.min((n-t0)/d,1), z=1-Math.pow(1-p,3); el.textContent=Math.round(z*t)+s; if(p<1) requestAnimationFrame(k); })(t0); co.unobserve(el); }); },{ threshold:.5 });
      cs.forEach(function(e){ co.observe(e); });
      window.__oabCo = co;
    }
  }
  if (document.readyState !== 'loading') run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  // Safety net: if any in-viewport .fi is still hidden after 1.2s (observer delayed by a busy
  // main thread or back/forward-cache restore), force-reveal it so content is never stuck invisible.
  setTimeout(function(){
    var stuck = document.querySelectorAll('.oab .fi:not(.v)');
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < stuck.length; i++) {
      var r = stuck[i].getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) { stuck[i].classList.add('v'); }
    }
  }, 1200);
})();
